import 'angular:locale/data:uk';
import 'angular:locale/data:is';
import 'angular:locale/data:nn';
import 'angular:locale/data:tok';
import 'angular:locale/data:nb';
import 'angular:locale/data:kab';
import 'angular:locale/data:vi';
import 'angular:locale/data:it';
import 'angular:locale/data:de';
import 'angular:locale/data:eo';
import 'angular:locale/data:cs';
import 'angular:locale/data:gl';
import 'angular:locale/data:ca';
import 'angular:locale/data:eu';
import 'angular:locale/data:ja';
import 'angular:locale/data:fr';
import 'angular:locale/data:zh-Hant';
import 'angular:locale/data:zh-Hans';
import 'angular:locale/data:hr';
import 'angular:locale/data:sq';
import 'angular:locale/data:ru';
import 'angular:locale/data:pl';
import 'angular:locale/data:sv';
import 'angular:locale/data:pt-PT';
import 'angular:locale/data:pt';
import 'angular:locale/data:oc';
import 'angular:locale/data:es';
import 'angular:locale/data:el';
import 'angular:locale/data:gd';
import 'angular:locale/data:nl';
import 'angular:locale/data:fi';
import 'angular:locale/data:tr';
import 'angular:locale/data:th';
import 'angular:locale/data:hu';
import 'angular:locale/data:fa';
import 'angular:locale/data:ar';
import 'angular:locale/data:en';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
